"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBDocIncomePositive = function SvgBDocIncomePositive(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M98.583 141.964a2.262 2.262 0 01-2.261-2.261V46.216a2.262 2.262 0 114.523 0v93.487a2.262 2.262 0 01-2.262 2.261z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M119.874 47.301H28.272a2.262 2.262 0 010-4.523h91.602a2.262 2.262 0 010 4.523z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M27.315 68.133a2.262 2.262 0 01-2.262-2.262V2.26A2.262 2.262 0 0127.315 0h85.405c.6 0 1.174.24 1.598.663l14.325 14.325a2.263 2.263 0 11-3.205 3.197L111.785 4.524H29.607V65.87a2.262 2.262 0 01-2.292 2.262z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M134.199 143.45H27.315a2.262 2.262 0 010-4.524h104.622V29.403h-22.693a2.262 2.262 0 01-2.262-2.262V12.952a2.262 2.262 0 114.524 0V24.88h22.693a2.262 2.262 0 012.262 2.261v114.047a2.262 2.262 0 01-2.262 2.262zM73.613 18.788h-32.11a2.262 2.262 0 010-4.524h32.11a2.262 2.262 0 110 4.524zM66.534 32.984h-25.03a2.262 2.262 0 010-4.523h25.03a2.262 2.262 0 110 4.523z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M27.51 118.434a2.262 2.262 0 010-4.523A22.686 22.686 0 0038.67 71.623a2.262 2.262 0 012.262-3.905 27.217 27.217 0 01-13.42 50.701v.015zM14.935 115.215a2.262 2.262 0 01-1.108-.294 27.217 27.217 0 0113.382-50.913h.159a2.262 2.262 0 012.261 2.262l-.052 11.241a2.262 2.262 0 01-4.524 0V68.63a22.693 22.693 0 00-9.047 42.348 2.262 2.262 0 01-1.116 4.237h.045z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M27.187 106.19a9.688 9.688 0 01-6.665-2.578 2.264 2.264 0 013.099-3.302 5.217 5.217 0 003.558 1.357c2.661 0 4.825-1.847 4.825-4.116 0-2.45-2.518-3.936-5.006-4.14a12.251 12.251 0 01-3.25-.678c-3.64-1.47-5.91-4.524-5.91-7.946 0-4.81 4.192-8.686 9.341-8.686a9.703 9.703 0 016.544 2.466 2.262 2.262 0 11-3.016 3.347 5.202 5.202 0 00-3.505-1.29c-2.654 0-4.818 1.84-4.818 4.11 0 2.382 2.36 3.506 3.076 3.77a7.637 7.637 0 001.93.376c5.278.438 9.16 4.072 9.16 8.633-.022 4.802-4.214 8.678-9.363 8.678z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M27.307 121.427a2.262 2.262 0 01-2.262-2.261v-14.883a2.262 2.262 0 014.524 0v14.883a2.262 2.262 0 01-2.262 2.261z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M27.315 132.842a2.262 2.262 0 01-2.262-2.262V113a2.262 2.262 0 114.524 0v17.581a2.262 2.262 0 01-2.262 2.262z",
    fill: "#1B7"
  })));
};

var _default = SvgBDocIncomePositive;
exports["default"] = _default;